import { withFormik } from "formik";
import * as Yup from "yup";

const namePattern = /^[A-Za-z0-9 ]+$/;

export const getStoredSetupIntentId = (registrationData) => {
  const setupIntent = registrationData?.stripeSetupIntent;
  return (
    registrationData?.stripeSetupIntentId ??
    setupIntent?.setup_intent_id ??
    setupIntent?.id ??
    setupIntent?.setupIntentId ??
    null
  );
};

export const getStoredSetupIntentClientSecret = (registrationData) =>
  registrationData?.stripeSetupIntentClientSecret ??
  registrationData?.stripeSetupIntent?.client_secret ??
  registrationData?.stripeSetupIntent?.clientSecret ??
  null;

export const extractSetupIntentId = (setupIntentData) =>
  setupIntentData?.setup_intent_id ??
  setupIntentData?.id ??
  setupIntentData?.setupIntentId ??
  null;

export const extractSetupIntentClientSecret = (setupIntentData) =>
  setupIntentData?.client_secret ?? setupIntentData?.clientSecret ?? null;

export const extractPublishableKey = (tokenRes) => {
  const data = tokenRes?.data ?? tokenRes;
  return (
    data?.stripe_publishable_key ??
    data?.publishable_key ??
    data?.publishable_token ??
    tokenRes?.stripe_publishable_key ??
    tokenRes?.publishable_key ??
    tokenRes?.publishable_token ??
    null
  );
};

export const isStripeApiSuccess = (res) =>
  res?.status === true || res?.status === 1 || res?.status === "1";

/** Fallback copy when i18n keys are not yet in the translation API */
export const cardOnFileValidationMessageFallbacks = {};

export const cardOnFileInitialValues = {
  cardholderName: "",
  billingZipCode: "",
  cardNumberElement: null,
  cardExpiryElement: null,
  cardCvcElement: null,
};

const stripeFieldComplete = (value) => value === "valid";

export const cardOnFileValidationSchema = Yup.object().shape({
  cardholderName: Yup.string()
    .trim("SPACE_VALIDATION")
    .strict(true)
    .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
    .min(1, "CARDHOLDER_VAL")
    .required("CARDHOLDER_VAL"),
  cardNumberElement: Yup.mixed()
    .required("NUTRITION_CARD_VAL_CARD_NUMBER_REQUIRED")
    .test(
      "cardNumberComplete",
      "NUTRITION_CARD_VAL_CARD_NUMBER_INVALID",
      stripeFieldComplete
    ),
  cardExpiryElement: Yup.mixed()
    .required("NUTRITION_CARD_VAL_EXPIRY_REQUIRED")
    .test(
      "cardExpiryComplete",
      "NUTRITION_CARD_VAL_EXPIRY_INVALID",
      stripeFieldComplete
    ),
  cardCvcElement: Yup.mixed()
    .required("NUTRITION_CARD_VAL_CVV_REQUIRED")
    .test("cardCvcComplete", "NUTRITION_CARD_VAL_CVV_INVALID", stripeFieldComplete),
  billingZipCode: Yup.string()
    .matches(/^[0-9]+$/, "ONLY_DIGITS_VALIDATION")
    .min(5, "ZIP_FIVE_CHAR_VALIDATION")
    .max(5, "ZIP_FIVE_CHAR_VALIDATION")
    .required("ZIP_CODE_VALIDATION"),
});

export const isCardOnFileFormComplete = (values) => {
  try {
    cardOnFileValidationSchema.validateSync(values, { abortEarly: true });
    return true;
  } catch {
    return false;
  }
};

const formikEnhancer = withFormik({
  validationSchema: cardOnFileValidationSchema,
  mapPropsToValues: () => ({ ...cardOnFileInitialValues }),
  handleSubmit: () => {},
  displayName: "CardOnFileForm",
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: true,
  isInitialValid: false,
});

export default formikEnhancer;
